import { useCallback } from "react";

import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";
import { usePoller } from "src/organization/pages/project/environment/metrics/utils/polling";

import useObservabilityPipelineHttpClient from "./useObservabilityPipelineHttpClient";

const useServerCachesMetricsPoll = ({
  timeFrame
}: {
  timeFrame: TimeFrameType;
}) => {
  const client = useObservabilityPipelineHttpClient();

  const requestFn = useCallback(async () => {
    if (client === null) {
      return Promise.reject("Null value");
    }
    const response = await client.getServerCachesOverview(timeFrame, "wt", 1, [
      "web"
    ]);
    return response;
  }, [client, timeFrame]);

  return usePoller({
    requestFn: requestFn,
    timeFrame
  });
};

export default useServerCachesMetricsPoll;
